module.exports = __webpack_public_path__ + "static/media/key-icon.07d6244d.svg";